var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-card',{attrs:{"cancel-text":'_.close',"title":_vm.$t('_.credit_transactions')}},[_c('wallet-transactions-table',{attrs:{"id":"WTT","account-id":_vm.accountId,"data-scope":_vm.transactionsDataScope,"push-to-history":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }